import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "nk-searchbar__input" }
const _hoisted_2 = ["onKeyup"]
const _hoisted_3 = { class: "nk-searchbar__input__icon" }

import {
  ref,
} from 'vue';

import {
  NkIcon,
} from '@/core/components';

import { useRouter } from 'vue-router';
import NkSearchBarDropdown from './SearchBarDropdown/NkSearchBarDropdown.vue';
import { props as propsDefinition, DataType } from './searchBar.shared';
import {StSearchBar} from './searchBar.styled';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkSearchBar',
  props: propsDefinition,
  emits: ['change'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter();

const showDropdown = ref(false);
const selected = ref(0);




const current = ref('');

const clearCurrent = () => {
  current.value = '';
}

const openDropdown = () => {
  showDropdown.value = true;
};

const closeDropdown = () => {
  if ( !props.hasDropdown ) return;
  showDropdown.value = false;
  clearCurrent();
};

// Navigation

const redirect = (options: DataType['route']) => {
  router.push(options);
  closeDropdown();
}

const selectOption = (item: DataType) => {
  if (item.route) {
    redirect(item.route);
  }
};

const navigateEnter = () => {
  if (props.data.length > 0) {
    const item = props.data[selected.value];
    selectOption(item);
  }
};

const navigateDown = () => {
  if (selected.value < props.data.length - 1) {
    selected.value += 1;
  }
};

const navigateUp = () => {
  if (selected.value > 0) {
    selected.value -= 1;
  }
};

const onInput = () => {
  emit('change', current.value);

  if ( !props.hasDropdown ) return;

  selected.value = 0;
  if (current.value) {
    openDropdown();
  } else {
    closeDropdown();
	}
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StSearchBar), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Search",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((current).value = $event)),
          onKeyup: [
            _withKeys(navigateDown, ["down"]),
            _withKeys(navigateUp, ["up"]),
            _withKeys(navigateEnter, ["enter"])
          ],
          onInput: onInput,
          onBlur: closeDropdown
        }, null, 40, _hoisted_2), [
          [_vModelText, current.value]
        ]),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_unref(NkIcon), { name: "NkSearch" })
        ]),
        (showDropdown.value)
          ? (_openBlock(), _createBlock(NkSearchBarDropdown, {
              key: 0,
              data: props.data,
              selected: selected.value,
              loading: props.loading,
              onClick: selectOption
            }, null, 8, ["data", "selected", "loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})